import {MutationTree} from 'vuex';
import {
  EntityServiceTransaction, HistoryActivity,
  InformationServiceTransaction, JobRunning,
  ServiceTransaction,
  ServiceTransactionInitState
} from '@/store/service-transaction/service-transaction.types';

export const ServiceTransactionMutations: MutationTree<ServiceTransactionInitState> = {
  ['mutationGetServiceTransactions'](
    state: ServiceTransactionInitState,
    payload: EntityServiceTransaction[]
  ) {
    state.serviceTransactions = payload;
  },
  ['mutationGetServiceTransactionsHistory'](
    state: ServiceTransactionInitState,
    payload: EntityServiceTransaction[]
  ) {
    state.serviceTransactionHistory = payload;
  },
  ['mutationGenerateCode'](
    state: ServiceTransactionInitState,
    payload: EntityServiceTransaction
  ) {
    state.serviceTransaction = payload;
  },
  ['mutationVerifyCode'](
    state: ServiceTransactionInitState,
    payload: EntityServiceTransaction
  ) {
    state.serviceTransaction = payload;
  },
  ['mutationGetServiceTransaction'](
    state: ServiceTransactionInitState,
    payload: EntityServiceTransaction
  ) {
    state.serviceTransaction = payload;
  },
  ['mutationSetInformation'](
    state: ServiceTransactionInitState,
    payload: InformationServiceTransaction
  ) {
    state.information = payload;
  },
  ['mutationSetRating'](state: ServiceTransactionInitState, payload: number) {
    state.rating = payload;
  },
  ['mutationSetJobRunning'](state: ServiceTransactionInitState, payload: JobRunning) {
    state.jobRunning = payload;
  },
  ['mutationJobIsRunning'](state: ServiceTransactionInitState, payload: boolean) {
    state.jobIsRunning = payload;
  },
  ['mutationService'](state: ServiceTransactionInitState, payload: EntityServiceTransaction) {
    state.service = payload;
  },
  ['mutationGetServiceTransactionInviteReceiver'](state: ServiceTransactionInitState, payload: EntityServiceTransaction[]) {
    state.inviteReceiver = payload;
  },
  ['mutationGetServiceTransactionInviteProvider'](state: ServiceTransactionInitState, payload: EntityServiceTransaction[]) {
    state.inviteProvider = payload;
  },
  ['mutationGetHistoryActivity'](state: ServiceTransactionInitState, payload: HistoryActivity[]) {
    state.historyActivity = payload;
  },
};
